<div id="controls">
  <button (click)="hangup()" [disabled]="!enable" [ngClass]="{ active: enable }" id="hangup">
    <div class="tooltip">
      <p>Al finalizar, recuerde colgar la Videoconsulta</p>
    </div>
    <img src="../../../assets/img/hangup.png" alt="Icono colgar" />
  </button>
  <app-camara-controls
    [camOpen]="camOpen"
    [isMedic]="m"
    (toogleCam)="toogleCam($event)"
    (changeBackgroundEffect)="changeBackground($event)"
  ></app-camara-controls>
  <button (click)="mute()" [ngClass]="{ disable: !micOpen }">
    <img src="../../../assets/img/mic.png" alt="Icono microfono" />
  </button>
</div>